import { render, staticRenderFns } from "./LayoutForm.vue?vue&type=template&id=064b5f86&"
import script from "./LayoutForm.vue?vue&type=script&lang=js&"
export * from "./LayoutForm.vue?vue&type=script&lang=js&"
import style0 from "./LayoutForm.vue?vue&type=style&index=0&id=064b5f86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports